import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './Spinner.css';

// size: sm | md | lg; tone: brand (brend rangida) | current (ota element rangida)
const Spinner = forwardRef(function Spinner(
  { size = 'md', tone = 'brand', label = 'Yuklanmoqda', className, ...rest },
  ref
) {
  return (
    <span
      {...rest}
      ref={ref}
      role="status"
      aria-label={label}
      className={cx('ui-spinner', `ui-spinner--${size}`, `ui-spinner--${tone}`, className)}
    />
  );
});

export default Spinner;
